/**
 * @file Created on Fri Jul 27 2018
 * @author VBr
 */
import { Header } from './Header';
export default Header;